module.exports = __webpack_public_path__ + "static/media/carta_40.f41a9057.jpg";